import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import { match } from 'ts-pattern'

type InvoiceStatus = Dashboardv99990101Api.Invoices.InvoiceStatus

export const getHumanReadableInvoiceNumber = ({
  invoiceNumber,
  invoiceStatus
}: {
  invoiceNumber: string | undefined
  invoiceStatus: InvoiceStatus | undefined
}): string => {
  return match(invoiceStatus)
    .with('IN_PROGRESS', () => 'Upcoming invoice')
    .with('DRAFT', () => 'Draft invoice')
    .otherwise(() => invoiceNumber ?? 'Draft invoice')
}
